module.exports = "<p>\n  single-order works!\n</p>\n"